export const buildPrimaryIdCriteria = (primaryId) => ({
  primaryId
});

export const normalizePrimaryIdCriteria = (criteriaOrPrimaryId) => {
  if (
    criteriaOrPrimaryId
    && typeof criteriaOrPrimaryId === "object"
    && !Array.isArray(criteriaOrPrimaryId)
  ) {
    return criteriaOrPrimaryId;
  }

  return buildPrimaryIdCriteria(criteriaOrPrimaryId);
};

export const buildUserCartItemPayload = (email, course, schedule) => ({
  email,
  course,
  schedule
});
